var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{style:(_vm.shouldDisplay ? 'display: block;' : 'display: none;'),attrs:{"id":"fireworks-canvas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }